/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Force Flickity slider on mobile for Look sections
  function enableLookSliderOnMobile() {
    // Multiple attempts to catch the initialization
    const checkForLookSections = () => {
      const lookSections = document.querySelectorAll('[data-section-type="look"]');
      
      lookSections.forEach(function(section) {
        const sectionId = section.dataset.sectionId;
        const slider = section.querySelector('[data-slider]');
        
        if (slider && window.vf && window.vf[sectionId]) {
          const lookInstance = window.vf[sectionId];
          
          // Store original methods
          if (!lookInstance._originalCheckSlidesSize) {
            lookInstance._originalCheckSlidesSize = lookInstance.checkSlidesSize.bind(lookInstance);
            
            // Override checkSlidesSize to always enable slider on mobile when there are slides
            lookInstance.checkSlidesSize = function() {
              const isSmall = window.innerWidth < (window.theme?.sizes?.small || 768);
              const isLarge = window.innerWidth >= (window.theme?.sizes?.large || 1024);
              const isMedium = window.innerWidth >= (window.theme?.sizes?.small || 768) && window.innerWidth < (window.theme?.sizes?.large || 1024);
              
              // Get slides count
              const slidesCount = this.slides ? this.slides.length : slider.children.length;
              
              // Get mobile products per row from CSS custom property
              const sliderElement = this.slider || slider;
              const computedStyle = window.getComputedStyle(sliderElement.closest('[data-section-type="look"]'));
              const mobileProductsPerRow = parseInt(computedStyle.getPropertyValue('--look-products-mobile')) || 1;
              
              const shouldInitOnLarge = Boolean(isLarge && slidesCount > this.productOnRow);
              const shouldInitOnMedium = Boolean(isMedium && slidesCount > 2);
              const shouldInitOnMobile = Boolean(isSmall && slidesCount > mobileProductsPerRow); // Enable based on mobile setting
              
              // Initialize tooltips if the method exists
              if (this.initTooltips) {
                this.initTooltips();
              }
              
              // Enable slider on mobile, medium, or large screens when appropriate
              if (shouldInitOnMobile || shouldInitOnMedium || shouldInitOnLarge) {
                if (this.initSlider) {
                  this.initSlider();
                }
              } else {
                if (this.destroySlider) {
                  this.destroySlider();
                }
                if (this.slidesTabIndex) {
                  this.slidesTabIndex();
                }
              }
            };
            
            // Force immediate re-check
            lookInstance.checkSlidesSize();
          }
        }
      });
    };
    
    // Try multiple times with different delays
    setTimeout(checkForLookSections, 100);
    setTimeout(checkForLookSections, 500);
    setTimeout(checkForLookSections, 1000);
    setTimeout(checkForLookSections, 2000);
  }

  // Direct Flickity initialization as fallback
  function forceFlickityOnMobile() {
    const lookSections = document.querySelectorAll('[data-section-type="look"]');
    
    lookSections.forEach(function(section) {
      const slider = section.querySelector('[data-slider]');
      const isSmall = window.innerWidth < 768;
      
      if (slider && isSmall && slider.children.length > 0) {
        // Get mobile products per row from CSS custom property
        const computedStyle = window.getComputedStyle(section);
        const mobileProductsPerRow = parseInt(computedStyle.getPropertyValue('--look-products-mobile')) || 1;
        
        // Only initialize if we have more products than can fit per row
        if (slider.children.length > mobileProductsPerRow) {
          // Check if Flickity is already initialized
          const existingFlickity = window.theme?.Flickity?.data(slider);
          
          if (!existingFlickity && !slider.classList.contains('flickity-enabled')) {
            // Force initialize Flickity directly
            if (window.theme && window.theme.Flickity) {
              try {
                // Ensure proper CSS classes
                slider.style.display = 'block';
                
                const flkty = new window.theme.Flickity(slider, {
                  pageDots: true,
                  cellAlign: 'left',
                  groupCells: mobileProductsPerRow > 1 ? mobileProductsPerRow : false,
                  contain: true,
                  wrapAround: false,
                  adaptiveHeight: false,
                  prevNextButtons: true,
                  cellSelector: '.look__slide',
                  freeScroll: false,
                  percentPosition: false
                });
                
                // Force re-layout after initialization
                setTimeout(() => {
                  if (flkty && flkty.resize) {
                    flkty.resize();
                  }
                }, 100);
                
                console.log('Flickity manually initialized for mobile:', section.dataset.sectionId, 'Products per row:', mobileProductsPerRow);
              } catch (error) {
                console.error('Failed to initialize Flickity:', error);
                
                // Fallback: Simple CSS scroll
                slider.style.display = 'flex';
                slider.style.overflowX = 'auto';
                slider.style.scrollSnapType = 'x mandatory';
                Array.from(slider.children).forEach(child => {
                  child.style.flexShrink = '0';
                  child.style.scrollSnapAlign = 'start';
                  child.style.width = `calc((100% - 15px * ${mobileProductsPerRow - 1}) / ${mobileProductsPerRow})`;
                  child.style.marginRight = '15px';
                });
              }
            } else {
              // Fallback if Flickity not available: Simple CSS scroll
              slider.style.display = 'flex';
              slider.style.overflowX = 'auto';
              slider.style.scrollSnapType = 'x mandatory';
              Array.from(slider.children).forEach(child => {
                child.style.flexShrink = '0';
                child.style.scrollSnapAlign = 'start';
                child.style.width = `calc((100% - 15px * ${mobileProductsPerRow - 1}) / ${mobileProductsPerRow})`;
                child.style.marginRight = '15px';
              });
            }
          }
        }
      }
    });
  }

  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      enableLookSliderOnMobile();
      setTimeout(forceFlickityOnMobile, 2500); // Fallback after 2.5 seconds
    });
  } else {
    enableLookSliderOnMobile();
    setTimeout(forceFlickityOnMobile, 2500);
  }

  // Also run when window loads (for additional safety)
  window.addEventListener('load', function() {
    enableLookSliderOnMobile();
    setTimeout(forceFlickityOnMobile, 1000);
  });

  // Listen for resize events to re-trigger the logic
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      enableLookSliderOnMobile();
      setTimeout(forceFlickityOnMobile, 500);
    }, 250);
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
